import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import ItemsLoading from '../../../../components/Loaders/ItemsLoading'
import SkeletonListRow from '../../../../features/components/List/Skeleton'
import PageSection from '../../../../features/components/PageSection'
import List from '../../../../features/components/List'

import { useLoadPaginatedAudienceList } from '../hooks'

import {
  audiencesAfterSelector,
  audiencesErrorSelector,
  audiencesIsNextSelector,
  audiencesLoadingSelector,
  audiencesSelector,
  audiencesWasLoadedSelector
} from '../../../../modules/selectors/audiences'
import { selectedPartnershipSelector } from '../../../../modules/selectors/partnerships'
import { clearAudiences, getAudiences } from '../../../../modules/actions/audiences'

import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'

import { columns } from './columns'

import useCommonStyles from '../../../../styles/common/listPage'

const FacebookAudienceTable = () => {
  const commonClasses = useCommonStyles()

  const audiences = useSelector(audiencesSelector)
  const audiencesNext = useSelector(audiencesIsNextSelector)
  const audiencesAfter = useSelector(audiencesAfterSelector)

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const facebookAdAccountId = selectedPartnership?.facebook_ad_account?.external_id

  const listSkeletonProps = useMemo(() => ({ cols: columns }), [])

  const params = useMemo(() => {
    return {
      account: facebookAdAccountId
    }
  }, [facebookAdAccountId])

  const loadMoreHandler = useLoadPaginatedAudienceList({
    platform: FACEBOOK_PLATFORM,
    params,
    action: getAudiences,
    clearAction: clearAudiences,
    next: audiencesNext,
    after: audiencesAfter
  })

  return (
    <ItemsLoading
      loadMore={loadMoreHandler}
      className={commonClasses.itemList}
      itemsLength={audiences.length}
      SkeletonComponent={SkeletonListRow}
      skeletonProps={listSkeletonProps}
      errorSelector={audiencesErrorSelector}
      isLoadingSelector={audiencesLoadingSelector}
      wasLoadedSelector={audiencesWasLoadedSelector}
      ContentWrapper={PageSection}
    >
      <List cols={columns} listData={audiences} Skeleton={<SkeletonListRow {...listSkeletonProps} />} />
    </ItemsLoading>
  )
}

export default FacebookAudienceTable
